// Logo oficial de The W Project — versión blanca con transparencia real (servida desde /public).
export const Logo = ({ className = "", imgClass = "h-10" }) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo-white.png`}
    alt="The W Project"
    className={`${imgClass} w-auto object-contain select-none ${className}`}
    draggable="false"
  />
);
